import { useAuth } from "../contexts/AuthContext";
import { usePreferredLanguageSync } from "../hooks/usePreferredLanguageSync";

/**
 * Componente sin UI: guarda el idioma preferido del usuario en la base de datos
 * para que las notificaciones del servidor lleguen traducidas.
 */
const PreferredLanguageSyncInner = () => {
  usePreferredLanguageSync();
  return null;
};

export const PreferredLanguageSync = () => {
  const { user } = useAuth();
  if (!user) return null;
  return <PreferredLanguageSyncInner />;
};
